import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewRelatedDeviceType from './viewRelatedDeviceType';
import viewRelatedUsers from './viewRelatedUsers';

export default {
  title: 'General values',
  attributeName: 'device',
  fields: [
    {
      attributeName: 'deviceId',
      label: 'Device ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Device identifier...',
      helpText: 'Unique hardware or platform identifier for the device.',
    },
    {
      attributeName: 'tags',
      label: 'Tags',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Optional tags...',
      helpText: 'Optional tags to help identify or group this device.',
    },
    {
      attributeName: 'type',
      label: 'Device Type',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      configFile: viewRelatedDeviceType,
      default: [],
      helpText: 'Select the VR device model (e.g. Meta Quest 2, HTC Vive Pro 2).',
      disabledWhenEdit: false,
    },
    {
      attributeName: 'user',
      label: 'Assigned User',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      configFile: viewRelatedUsers,
      default: [],
      helpText: 'Assign a user to this device (optional). Leave empty to keep it unassigned.',
      disabledWhenEdit: false,
    },
  ],
};
